import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            为什么选择我们
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            让创作变得更简单
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            91short为每一位创作者提供最强大的工具和最优质的平台体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}